import { useId } from 'react';

function useGeneratedId(fallback, prefix) {
  const id = useId();
  if (fallback) return fallback;
  return `${prefix !== null && prefix !== void 0 ? prefix : ''}${id}`;
}

export { useGeneratedId };
//# sourceMappingURL=useGeneratedId.js.map
